import React from 'react';
import { ProgressBar } from 'react-bootstrap';

/**
 * @copyright Optimum Tracker
 * @author bblin
 */
class Trackers extends React.Component
{
    round(percent)
	{
		if(percent % 1 === 0) {
			return percent;
		}
		return Math.round(percent * 10) / 10;
	}
	
	adjustProgress(percent)
	{
		if(percent === 100) {
			return 100;
		}
		if(percent === 0 || percent === null) {
			return 0;
		}
		const floors = [87.5, 75, 62.5, 50, 37.5, 25];
		for(let floor of floors) {
			if(percent >= floor) {
				return floor;
			}
		}
		return 12.5;
	}

	render()
	{
        let infoTracker = `${Math.trunc(this.props.powerplant.getPercentAuto())}% / ${this.props.powerplant.getNbTrackersTotal()}`;
        return (
				<div className="tracker-progress-bar-container">
					<div className="message-position text-center">
							{' '+ infoTracker}
					</div>
					<ProgressBar bsStyle="success" 
                        className="tracker-progress-bar progress-bar active progress-bar-striped" 
                        style={{borderRadius:'20px', width:'100%', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif', backgroundColor:'#B2B6BB'}} 
                        now={this.props.powerplant.getPercentAuto()} />
				</div>
		);
	}
}

Trackers.defaultProps = {
    powerplant: {}}

export default Trackers;